<template>
    <div>
        <div class="loader" :class="loading && 'active'">
            <img src="/img/loader.svg" alt="" />
        </div>
        <iframe :src="reciept_link" v-if="reciept_link" />
    </div>
</template>

<script>
    export default {
        name: 'Reciept',
        data() {
            return {
                reciept_link: '',
                loading: true,
            };
        },
        created() {

        },
        mounted() {
            var elem = this;
            var t = setInterval(function () {
                elem.$api.get('/order/get-receipt/?order_key=' + elem.$route.query.order_key).then((response) => {
                    if (response.error) {
                        elem.loading = false;
                        elem.$alert(response.error.message);
                        clearInterval(t);
                    } else {
                        if (response.receipt_link) {
                            elem.reciept_link = response.receipt_link;
                            clearInterval(t);
                        } else {
                            elem.$alert(response.receipt_status);
                        }
                    }
                }).catch((error) => {
                    elem.$alert('Ошибка создания чека');
                    elem.loading = false;
                    clearInterval(t);
                });
            }, 5000);
        },
        methods: {
            close() {

            }
        },
    };
</script>

<style>
</style>
